module.exports = __webpack_public_path__ + "static/media/mbis_img_3.363af77e.png";